import React from "react";
import { Section } from "./Section";
export function OfferTeaser() {
  return <Section tone="navy" labelledBy="teaser-title" cta="Yes, I want the complete system" ctaNote="No subscription. No recurring fees." data-id="element-235" data-mp="31p1v4v58rzqr">
      <div className="text-center" data-id="element-236" data-mp="3gmu9vl2ysk3w">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-gold-light sm:text-sm" data-id="element-237" data-mp="3gjzsk2f8zfep">The special offer</p>
        <h2 id="teaser-title" className="mt-3 font-serif text-[1.95rem] font-bold leading-tight sm:text-4xl md:text-5xl" data-id="element-238" data-mp="3pmr3m147o95t">
          Get the Complete Facelift Blueprint™ for Just <span className="text-gold-light" data-id="element-239" data-mp="3kne8kt36rvs5">$27</span>
        </h2>
        <p className="mt-4 text-lg font-semibold text-white" data-id="element-240" data-mp="364p2rkddkgw">6 Premium Volumes + 5 Professional Bonuses</p>
        <p className="mt-1 text-white/70" data-id="element-241" data-mp="3uesbzby9dfqk">Instant digital access. No subscription. No recurring fees.</p>
      </div>
    </Section>;
}